'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card } from '@achra/ui/card';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@achra/ui/form';
import { Input } from '@achra/ui/input';
import { ArrowRight } from 'lucide-react';
import { type UseFormReturn, useWatch } from 'react-hook-form';
import { type PersonaId, PERSONAS } from '@/modules/onboarding/lib/personas';
import { stepOneSchema, type StepOneValues } from '@/modules/onboarding/lib/schemas';
import { PersonaCard } from './persona-card';
interface ChooseRoleStepProps {
  form: UseFormReturn<StepOneValues>;
  onSubmit: () => void;
}
function ChooseRoleStep(t0) {
  const $ = _c(31);
  const {
    form,
    onSubmit
  } = t0;
  let t1;
  if ($[0] !== form.control) {
    t1 = {
      control: form.control
    };
    $[0] = form.control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const watched = useWatch(t1);
  const selectedPersonaId = watched.personaId;
  let t2;
  if ($[2] !== watched) {
    t2 = stepOneSchema.safeParse(watched);
    $[2] = watched;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isFormValid = t2.success;
  let t3;
  if ($[4] !== form) {
    t3 = function handlePersonaSelect(id) {
      form.setValue("personaId", id, {
        shouldValidate: true,
        shouldTouch: true
      });
    };
    $[4] = form;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handlePersonaSelect = t3;
  let t4;
  if ($[6] !== form || $[7] !== onSubmit) {
    t4 = event => {
      event.preventDefault();
      form.handleSubmit(onSubmit)(event);
    };
    $[6] = form;
    $[7] = onSubmit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="px-8 pt-8 pb-2"><p className="text-muted-foreground text-xs font-semibold tracking-wider uppercase">Get started</p><h1 className="mt-1.5 text-3xl font-semibold tracking-tight">Choose your role on Achra</h1><p className="text-muted-foreground mt-2 max-w-lg text-sm">We'll spin up a Connect drive tailored to what you're here to do.</p></div>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handlePersonaSelect || $[11] !== selectedPersonaId) {
    t6 = () => <FormItem className="gap-3"><div role="radiogroup" aria-label="Choose your role" className="grid gap-3 sm:grid-cols-3">{PERSONAS.map(persona => <PersonaCard key={persona.id} persona={persona} selected={selectedPersonaId === persona.id} onSelect={() => {
          handlePersonaSelect(persona.id);
        }} />)}</div><FormMessage /></FormItem>;
    $[10] = handlePersonaSelect;
    $[11] = selectedPersonaId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== form.control || $[14] !== t6) {
    t7 = <FormField control={form.control} name="personaId" render={t6} />;
    $[13] = form.control;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== form.control) {
    t8 = <FormField control={form.control} name="displayName" render={_temp} />;
    $[16] = form.control;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex flex-col gap-6 px-8 py-6">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = !isFormValid;
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ArrowRight className="size-4" aria-hidden="true" />;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10) {
    t12 = <div className="bg-muted/40 border-border flex justify-end border-t px-8 py-5"><Button type="submit" disabled={t10} className="gap-2 sm:w-fit">Set up my workspace{t11}</Button></div>;
    $[22] = t10;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t4 || $[26] !== t9) {
    t13 = <form noValidate={true} onSubmit={t4} className="flex flex-col">{t5}{t9}{t12}</form>;
    $[24] = t12;
    $[25] = t4;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== form || $[29] !== t13) {
    t14 = <Card className="gap-0 overflow-hidden py-0"><Form {...form}>{t13}</Form></Card>;
    $[28] = form;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem className="max-w-md"><FormLabel>Display name</FormLabel><FormControl><Input {...field} type="text" placeholder="e.g. alex.eth" autoComplete="nickname" /></FormControl><FormDescription>Shown on your drive and any offerings.</FormDescription><FormMessage /></FormItem>;
}
export { ChooseRoleStep };